import {Component, Vue} from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import {Page} from '@/router';

@Component({
    components: {
        Modal
    }
})
export default class CancelMixin extends Vue {
    protected showCancel = false;

    cancelClicked() {
        this.showCancel = true;
    }

    closeCancel() {
        this.showCancel = false;
    }

    clearCart() {
        this.$store.commit('clearCart');
        this.showCancel = false;
        this.$router.replace(Page.DVD_ORDER).catch(() => {});
    }
}